import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointWelcomeData, type EnrollmentJointWelcomeSubmitOutput } from '../../../../models'

export const getEnrollmentJointWelcomeDataMock: EnrollmentJointWelcomeData = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/welcome',
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
  },
  jointPerson: {
    name: {
      firstName: 'Jane',
      lastName: 'Doe',
    },
  },
}

export const submitEnrollmentJointWelcomeDataMock: EnrollmentJointWelcomeSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/create-passkey',
  },
}

export const mockGetEnrollmentJointWelcomeData = graphql.mutation('getEnrollmentJointWelcomeData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointWelcomeDataMock } })
})

export const mockSubmitEnrollmentJointWelcomeData = graphql.mutation('submitJointEnrollmentJointWelcomeData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointWelcomeDataMock } })
})

export const mockEnrollmentJointWelcome = [mockGetEnrollmentJointWelcomeData, mockSubmitEnrollmentJointWelcomeData]
